import { render } from "./ArtistList.vue?vue&type=template&id=1ac5c1ca&scoped=true"
import script from "./ArtistList.vue?vue&type=script&lang=js"
export * from "./ArtistList.vue?vue&type=script&lang=js"

import "./ArtistList.vue?vue&type=style&index=0&id=1ac5c1ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ac5c1ca"]])

export default __exports__